<template>
    <div id="layout-footer">
        <div class="footer-main">
            <div class="footer-item" v-if="socials.length">
                <div v-for="item in socials" :key="item.id"><a target="_blank" class="out-link" :href="item.href"><i class="iconfont" :class="item.icon"></i>{{item.title}}</a></div>
            </div>
            <div class="footer-item">
                <div style="font-size:17px;font-weight: bold;">资源</div>
                <div><a target="_blank" class="out-link" href="https://uniapp.dcloud.net.cn/">uni-app</a></div>
                <div><a target="_blank" class="out-link" href="https://www.csdn.net/">CSDN</a></div>
                <div><a target="_blank" class="out-link" href="https://juejin.cn/">稀土掘金</a></div>
            </div>
            <div class="footer-item">
                <div>本站已苟活 {{runTimeInterval}}</div>
                <div><a target="_blank" class="out-link" href="#">☞后台管理</a></div>
            </div>
        </div>
        <div class="copyright">
            <div>Copyright © 2023 by <a target="_blank" class="out-link" href="https://www.yuerongyi.top">yuerongyi.top</a> </div>  
            <span style="display:flex;align-items: center;margin:1% 0;">
                <a target="_blank" class="out-link" href="https://beian.miit.gov.cn/">黔ICP备2023015744号-3</a>
                <img style="width:1.8vmin;height:1.8vmin;margin:0 2px 0 10px;" src="@/assets/images/badge.png"/> 
                <a target="_blank" class="out-link" href="https://beian.mps.gov.cn/#/query/webSearch?code=52260102556441">贵公网安备52260102556441号</a>
            </span>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/section-title'
    export default {
        name: "layout-footer",
        data(){
            return{
                socials: []
            }
        },
        components:{
            sectionTitle
        },
        computed:{
            runTimeInterval() {
                return this.$store.state.runTimeInterval;
            }
        },
        methods:{
            getSocial(){
                this.$store.dispatch('getSocials').then(data =>{
                    this.socials = data
                })
            },
        },
        created(){
            this.getSocial();
            this.$store.dispatch('initComputeTime');
        }
    }
</script>

<style scoped lang="less">
#layout-footer{
    padding: 2%;
    border-top: 1px solid #F7F7F7;
    font-size: 14px;
    color: #9c9c9c;
    background: rgba(46,58,75,1);
    a.out-link:hover{
        color: #eded4a;
    }
    .footer-main{
        max-width: 800px;
        margin: 0 auto 20px auto;
        display: flex;
        justify-content: space-around;
        align-items: flex-start;
        .footer-item{
            flex: 1;
            & > div:not(:last-child){
                margin-bottom: 10px;
            }
            i{
                margin-right: 10px;
            }
        }
    }
    .copyright{
        text-align: center;
        display:flex;
        align-items: center;
        flex-direction: column;
        justify-content: center
    }
}
    /*****/
    @media (max-width: 800px){
        #layout-footer{
            .footer-main .footer-item:nth-child(3){
                flex: 2;
            }
        }
    }
    @media (max-width: 600px){
        #layout-footer{
            .footer-main {
                display: block;
                .footer-item{
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    flex-wrap: wrap;
                    & > div{
                        margin-bottom: 10px;
                    }
                }
            }
        }
    }
    /*****/
</style>